import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Drawer, message, Checkbox, Row, Col } from 'antd';
import { postApiWithAuthToken, getApiWithAuthToken, getApiWithPublicAuthToken, updateApiWithAuthToken } from '../../../api';

const BranchForm = ({ handleDrawerClose, isDrawerVisible, getBranchList, branch }) => {
    const [form] = Form.useForm();

    // Get dropdown data 
    const [managerList, setManagerList] = useState([]);
    const [languageList, setLanguageList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [areaList, setAreaList] = useState([]);

    function getManagerList() {
        getApiWithAuthToken('/api/v1/admin/managers').then((res) => {
            if (res.data && res.data.length > 0) {
                setManagerList(res.data);
            }
        });
    }
    function getLanguageList() {
        getApiWithPublicAuthToken('/api/v1/public/languageList').then((res) => {
            if (res.data && res.data.length > 0) {
                setLanguageList(res.data);
            }
        });
    }
    function getCurrencyList() {
        getApiWithPublicAuthToken('/api/v1/public/currencyList').then((res) => {
            if (res.data && res.data.length > 0) {
                setCurrencyList(res.data);
            }
        });
    }
    function getCountryList() {
        getApiWithPublicAuthToken('/api/v1/public/countryList').then((res) => {
            if (res.data && res.data.length > 0) {
                setCountryList(res.data);
            }
        });
    }
    function getRegionList() {
        getApiWithPublicAuthToken('/api/v1/admin/regions').then((res) => {
            if (res.data && res.data.length > 0) {
                setRegionList(res.data);
            }
        });
    }
    function getAreaList() {
        getApiWithPublicAuthToken('/api/v1/admin/areas').then((res) => {
            if (res.data && res.data.length > 0) {
                setAreaList(res.data);
            }
        });
    }

    useEffect(() => {
        getManagerList();
        getLanguageList();
        getCurrencyList();
        getCountryList();
        getRegionList();
        getAreaList();
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [branch]);

    // Form Submit 

    const handleSubmit = () => {
        form.submit();
    };

    const onFinish = (values) => {
        message.loading({ content: 'Processing...', key: 'form' });
        if (branch.id) {
            updateApiWithAuthToken(`/api/v1/admin/branches/${branch.id}`, values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getBranchList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        } else {
            postApiWithAuthToken('/api/v1/admin/branches', values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getBranchList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        }
    };

    return (
        <Drawer
            title={branch.id ? "Edit branch" : "Add branch"}
            width={480}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div style={{ textAlign: 'right', }}>
                    <Button onClick={handleDrawerClose} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} type="primary">
                        Submit
                    </Button>
                </div>
            }
        >
            <Form layout="vertical"
                hideRequiredMark
                form={form}
                onFinish={onFinish} >
                <Form.Item
                    name="name"
                    label="Name"
                    initialValue={branch.name}
                    rules={[{ required: true, message: 'This field is required' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="manager"
                    label="Manager"
                    initialValue={managerList.find(manager => manager.name === branch.manager) ? managerList.find(manager => manager.name === branch.manager).id : null}
                    rules={[{ required: true, message: 'This field is required' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select a manager"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {managerList.length &&
                            managerList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="lang"
                    label="Language"
                    initialValue={languageList.find(language => language.name === branch.lang) ? languageList.find(language => language.name === branch.lang).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a language"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {languageList.length &&
                            languageList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="currency"
                    label="Currency"
                    initialValue={currencyList.find(currency => currency.name === branch.currency) ? currencyList.find(currency => currency.name === branch.currency).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a currency"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {currencyList.length &&
                            currencyList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="country"
                    label="Country"
                    initialValue={countryList.find(country => country.name === branch.country) ? countryList.find(country => country.name === branch.country).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a country"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {countryList.length &&
                            countryList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="region"
                    label="Region"
                    initialValue={regionList.find(region => region.name === branch.region) ? regionList.find(region => region.name === branch.region).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a region"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {regionList.length &&
                            regionList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="area"
                    label="Area"
                    initialValue={areaList.find(area => area.name === branch.area) ? areaList.find(area => area.name === branch.area).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a area"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {areaList.length &&
                            areaList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="address"
                    label="Address"
                    initialValue={branch.address}
                >
                    <Input.TextArea />
                </Form.Item>
            </Form>
        </Drawer >
    );
};
export default BranchForm;
